import moment from "moment";
import { getBrowsersInfo } from "../enhancers/utils";
import packageJson from "../../package.json";

export const baseServerUrl = "https://apps-garfo.fisheries.noaa.gov";

export const devServerUrl = "https://dev-www-garfo.woc.noaa.gov";

export const folURL =
  "https://www.fisheries.noaa.gov/new-england-mid-atlantic/resources-fishing/vessel-trip-reporting-greater-atlantic-region";

export const checkTokenValid = function (sessionInfo) {
  let tokenValid = false;
  if (
    sessionInfo &&
    sessionInfo.hasOwnProperty("token_expires") &&
    sessionInfo.token_expires
  ) {
    let expirationTime = moment(sessionInfo.token_expires * 1000).format(
      "YYYY-MM-DD HH:mm"
    );
    if (expirationTime > moment().subtract(5, "minutes").format("YYYY-MM-DD HH:mm")) {
      tokenValid = true;
    }
  }
  return tokenValid;
};

export const REQUEST_TIMEOUT = 30000;
export const TIMEOUT_MESSAGE = "A timeout occurred, please try again later.";
export const BAD_RESPONSE_MESSAGE = "Internal error, please try again later.";
export const AXIOS_ERROR = "AxiosError";
export const AXIOS_TIMEOUT_CODE = "ECONNABORTED";
export const AXIOS_BAD_RESPONSE = "ERR_BAD_RESPONSE";

function vendor_app_platform() {
  // * Replaced with new method that retrieves browser info.
  // * platform property was deprecated and needed to be replaced.
  // * will be storing an object with the info. Below sample object.
  // * { browser: 'chrome 135.0.0.0', os: 'OS X 10.15' }
  return JSON.stringify(getBrowsersInfo());
}
function vendor_app_name() {
  return "Fish Online React";
}

export const vendor_software_version = function () {
  return packageJson.version;
};
function vendor_id() {
  return "37901";
}

export const checkLoginFailure = (error) => {
  const foundError = error.error.toString().toLowerCase().includes("invalid credentials");
  return foundError;
};

export function login_request(username, password) {
  return {
    authorization: {
      username: username,
      password: password,
      vendor_id: vendor_id(),
      vendor_app_name: vendor_app_name(),
      vendor_software_version: vendor_software_version(),
      vendor_app_platform: vendor_app_platform(),
    },
  };
}

export function default_request(client_id, token, user_app_status, not_exclude = true) {
  let test_user;
  let request = {};
  if (user_app_status === "TEST") {
    test_user = true;
  }
  if (not_exclude) {
    request = { authorization: { client_id, token } };
  }
  request = {
    ...request,
    client_id,
    token,
    test_user,
    vendor_id: vendor_id(),
    vendor_app_name: vendor_app_name(),
    vendor_software_version: vendor_software_version(),
    vendor_app_platform: vendor_app_platform(),
  };

  return request;
}

export function ivrRequest(client_id, token, user_app_status, vesselNbr) {
  let defaultRequest = default_request(client_id, token, user_app_status);
  defaultRequest.vessel = vesselNbr;
  return defaultRequest;
}

export function checkStoredMessage(client_id) {
  if (!client_id) return;

  const localStorageKey = `broadcastedMessages_${client_id}`;
  const storedMessages = JSON.parse(localStorage.getItem(localStorageKey)) || [];
  const validMsgDates = storedMessages.filter(
    (validDate) =>
      moment(validDate.TIME_END, "DD-MMM-YY").diff(moment().format(), "days") > 0
  );
  return validMsgDates;
}

export function newBroadcastedMessages(client_id) {
  if (!client_id) return 0;

  const loginResponse = JSON.parse(localStorage.getItem("loginResponse")) || [];
  let newMessages = [];
  if (
    loginResponse.hasOwnProperty("broadcast_message") &&
    Array.isArray(loginResponse.broadcast_message)
  ) {
    newMessages = loginResponse.broadcast_message;
  }
  const readMessages = checkStoredMessage(client_id);
  let noMessages = 0;
  let noRead = [];

  if (readMessages.length > 0) {
    noRead = newMessages.filter(
      (newMsg) =>
        !readMessages.some(
          (readMsg) =>
            newMsg.POST_ID === readMsg.POST_ID &&
            moment(newMsg.TIME_END, "DD-MMM-YY").diff(
              moment(readMsg.TIME_END, "DD-MMM-YY"),
              "days"
            ) === 0
        )
    );
  }

  noMessages = readMessages
    ? Object.entries(noRead).length
    : Object.entries(newMessages).length;

  return noMessages;
}

export function loadUserSelection(client_id) {
  if (!client_id) return;

  const localStorageKey = `userSelection_${client_id}`;
  const storedSelection = JSON.parse(localStorage.getItem(localStorageKey)) || {};

  return storedSelection;
}

export function saveUserSelection(client_id, selection) {
  if (!client_id) return;

  const localStorageKey = `userSelection_${client_id}`;
  const selectionToStored = { latLonFormat: selection };
  localStorage.setItem(localStorageKey, JSON.stringify(selectionToStored));
}
